import { IconArrowCorners } from '@veneer/core';
import React from 'react';
import {
  ManageYourInstantInkPlanButtonClicked,
  ManageYourAllInPlanButtonClicked
} from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';
import { SubscriptionsCardProps } from '../SubscriptionsCard/types';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import { ROW_TYPE, SubscriptionType } from '@uma/react-commons/dist/index';
import { CardRowProps } from '@uma/react-commons/dist/components/Card/CardWrapper/CardRow';
import { StyledCard } from '../../styles/styles';

export const MoreOptions = ({
  subscription
}: SubscriptionsCardProps): React.JSX.Element => {
  const { translate } = useDependencyManagerContext();

  const rows = [] as CardRowProps[];
  const isInstantInk = subscription?.type === SubscriptionType.INSTANT_INK;

  rows.push({
    index: 0,
    icon: <IconArrowCorners />,
    type: ROW_TYPE.EXTERNAL,
    content: translate(
      'subscriptions.manageYourPlan',
      'Manage your plan'
    ) as string,
    link: {
      url: isInstantInk
        ? URLS.ManageYourInstantInkPlan
        : URLS.ManageYourAllInPlan,
      dataTestId: 'ManageYourPlanButton'
    },
    analyticsEvent: isInstantInk
      ? ManageYourInstantInkPlanButtonClicked
      : ManageYourAllInPlanButtonClicked
  });

  return (
    <StyledCard
      title={{
        content: translate('common.moreOptions', 'More options') as string
      }}
      rows={rows}
      data-testid="more-options-section"
    />
  );
};
